// Player preferences — small key/value settings persisted to localStorage,
// independent of the game save (these are device/display choices, not progress).
// Generic on purpose so future toggles (sound, reduced motion, etc.) just add a
// DEFAULTS entry + a row in settingsPanel.js.

const KEY = 'mao.settings'
const DEFAULTS = {
  nightMode: true,       // day/night cycle (local-time lighting, lanterns, campfires, stars)
  buildingLabels: true,  // hover labels naming buildings + their purpose
  accentColor: 'jade',   // UI accent key (see game/accent.js ACCENTS); 'jade' = bright green (default)
}

let cache = null
const listeners = new Set()

function load() {
  if (cache) return cache
  cache = { ...DEFAULTS }
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) Object.assign(cache, JSON.parse(raw))
  } catch { /* corrupt / unavailable storage → defaults */ }
  return cache
}

export function getSetting(key) {
  return load()[key]
}

export function getAllSettings() {
  return { ...load() }
}

export function setSetting(key, value) {
  const s = load()
  if (s[key] === value) return
  s[key] = value
  try { localStorage.setItem(KEY, JSON.stringify(s)) } catch { /* ignore */ }
  for (const fn of listeners) fn(key, value)
}

// Subscribe to setting changes; returns an unsubscribe fn.
export function onSettingChange(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
